import {useDeck} from "../../deck-management/context/DeckContext";
import {useApiRequest} from "../../../common/hooks/useApiRequest";
import {ReviewSummaryItem, SessionSummary} from "../types/sessionTypes";
import {useQuery} from "@tanstack/react-query";

export interface UseReviewSummaryReturn {
    isPending: boolean
    isSuccess: boolean
    isError: boolean
    correctReviews: ReviewSummaryItem[]
    failedReviews: ReviewSummaryItem[]
}

function useReviewSummary(sessionId: string) : UseReviewSummaryReturn {

    const { currentDeck, ready : deckDataReady, isError: isDeckLoadError } = useDeck();

    const {getRequest} = useApiRequest();

    const {data: summary, isPending, isSuccess, isError: isSummaryLoadError} = useQuery({
        queryKey: ["summary", currentDeck?.deckId, sessionId],
        enabled: deckDataReady && !!sessionId,
        queryFn: () => getRequest<SessionSummary>(`decks/${currentDeck!.deckId}/review/session/${sessionId}/summary`),
    })

    return {
        isPending,
        isSuccess,
        isError: isDeckLoadError || isSummaryLoadError,
        correctReviews: isSuccess ? summary!.reviews.filter(review => review.fails === 0) : [],
        failedReviews: isSuccess ? summary!.reviews.filter(review => review.fails > 0) : [],
    }

}

export default useReviewSummary;